import { Component, Input, SimpleChanges, ViewChild, EventEmitter, Output } from '@angular/core';
import { IConnectRepository } from 'app/connect/core/IConnectRepository';
import { IConnectRepositoryFolder } from 'app/connect/core/IConnectRepositoryFolder';
import { ConnectEcmService } from 'app/connect/core/connect-ecm.service';

@Component({
  selector: 'connect-ecm-folders',
  templateUrl: 'connect-ecm-folders.component.html',
  styleUrls: ['connect-ecm-folders.component.scss']
})
export class ConnectEcmFoldersComponent {

  @ViewChild('selectFolders', { static: false}) ctrSelectFolders: any;
  @Input() selectedRepository: IConnectRepository;
  public showLoadingNodes = false;
  @Input() selectedFolder: IConnectRepositoryFolder;
  public foldersAvailable: any;
  public selectedFolders: any;

  ngOnChanges() {
    this.loadFolders();
  }

  constructor(private _connectEcmService: ConnectEcmService) { }

  public async loadFolders() {
    this.selectedFolders = {};
    if (this.selectedRepository.environment.params.externalId) {
      this.foldersAvailable = await this._connectEcmService.getConnectionFolders(
        this.selectedRepository.environment.params.externalId,
        this.selectedRepository.environment.params
      );
      this._resetSelectFolders();
      this.selectedFolder = null;
    }
  }

  async selectFolder(folder?) {
    if(this.selectedFolders[folder.id]) {
      this.selectedFolder = this.selectedFolders[folder.id];
    } else {
      this.selectedFolder = await this._connectEcmService.getFolder(folder.id);
      this.selectedFolder.folderId = folder.id;
      this.selectedFolders[folder.id] = this.selectedFolder;
    }
  }

  private _resetSelectFolders() {
    this.ctrSelectFolders.value = null;
    _.forEach(this.ctrSelectFolders.options._results, (opt: any) => {
      opt.selected = false;
    })
  }

  public getFoldersToSave() {
    return this.selectedFolders;
  }
}
